import React, { createContext, useContext, useState, useEffect } from "react";
import {
  fetchWorks,
  fetchPress,
  transformWorkData,
  transformPressData,
  testProxy,
} from "../utils/api";

const DataContext = createContext();

export const useData = () => {
  const context = useContext(DataContext);
  if (!context) {
    throw new Error("useData must be used within a DataProvider");
  }
  return context;
};

export const DataProvider = ({ children }) => {
  const [works, setWorks] = useState([]);
  const [press, setPress] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function loadAllData() {
      try {
        setLoading(true);
        setError(null);

        // Test proxy first
        await testProxy();

        // Fetch both APIs in parallel
        const [worksData, pressData] = await Promise.all([
          fetchWorks(),
          fetchPress(),
        ]);

        // Transform the data
        const transformedWorks = worksData.map(transformWorkData);
        const transformedPress = pressData.map(transformPressData);

        // Sort by date with newest first
        const sortedWorks = transformedWorks.sort(
          (a, b) => b.sortableDate - a.sortableDate
        );
        const sortedPress = transformedPress.sort(
          (a, b) => b.sortableDate - a.sortableDate
        );

        setWorks(sortedWorks);
        setPress(sortedPress);
      } catch (err) {
        console.error("Error loading data:", err);
        setError("Failed to load data");
      } finally {
        setLoading(false);
      }
    }

    loadAllData();
  }, []);

  const value = {
    works,
    press,
    loading,
    error,
  };

  return <DataContext.Provider value={value}>{children}</DataContext.Provider>;
};
